import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgLenght(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M14.667 0L20 5.333l-1.185 1.185-8.298 8.296.001.001L9.333 16 4 10.667l.149-.15 1.036-1.035 8.297-8.297zm-.001 2.369l-8.297 8.297 2.963 2.963 1.186-1.186-1.926-1.926 1.185-1.185 1.926 1.926 1.185-1.185-1.332-1.332 1.185-1.185 1.332 1.332 1.186-1.185-1.926-1.926 1.185-1.185 1.926 1.927 1.186-1.186z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Lenght')(SvgLenght);
